import { render, staticRenderFns } from "./BDivider.vue?vue&type=template&id=1267f777&scoped=true&"
import script from "./BDivider.vue?vue&type=script&lang=js&"
export * from "./BDivider.vue?vue&type=script&lang=js&"
import style0 from "./BDivider.vue?vue&type=style&index=0&id=1267f777&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1267f777",
  null
  
)

export default component.exports